import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import useUser from "./useUser";

const REFRESH_CHECK_INTERVAL = 10000; // Check every 10 seconds
export const REFRESH_IN_PROGRESS_KEY = "refresh_in_progress";

const UserInitializer = () => {
  const user = useUser();

  // Initialize logged in user when component mounts
  useEffect(() => {
    if (user.loggedIn && !user.initialized) {
      user.initialize().catch(() => {
        user.logOut();
      });
    }
  }, []);

  // Setup token refresh handling
  useEffect(() => {
    const refreshTimer = setInterval(async () => {
      try {
        if (
          user.needsTokenRefresh() &&
          localStorage.getItem(REFRESH_IN_PROGRESS_KEY) !== "true" &&
          document.visibilityState === "visible"
        ) {
          // Try to claim the refresh
          localStorage.setItem(REFRESH_IN_PROGRESS_KEY, "true");

          try {
            await user.refreshToken();
          } finally {
            localStorage.removeItem(REFRESH_IN_PROGRESS_KEY);
          }
        }
      } catch {
        user.logOut();
      }
    }, REFRESH_CHECK_INTERVAL);

    return () => {
      // Stop checking when component unmounts
      clearInterval(refreshTimer);
    };
  }, []);

  return <></>;
};

export default observer(UserInitializer);
